import { capitalize } from 'vue';

import Granularity from '@/common/enums/granularity.enum';
import i18n from '@/vueI18n';

import { Option } from '..';

export default class AudienceLookBackWindowPeriodTypes {
  static getLocalizedOptionName(name: string): string {
    return capitalize(i18n.global.t(`options.audienceLookBackWindowPeriodType.${name}`));
  }

  static options(): Option[] {
    return [
      Option.fromObject({
        value: Granularity.DAY,
        name: AudienceLookBackWindowPeriodTypes.getLocalizedOptionName('days'),
      }),
      Option.fromObject({
        value: Granularity.MONTH,
        name: AudienceLookBackWindowPeriodTypes.getLocalizedOptionName('months'),
      }),
      Option.fromObject({
        value: Granularity.YEAR,
        name: AudienceLookBackWindowPeriodTypes.getLocalizedOptionName('years'),
      }),
    ];
  }
}
